import routerOptions0 from "/src/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  sensitive: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}